// Shared display helpers for job data coming from external boards.
//
// Backend fetchers normalize descriptions/dates at the source now, but jobs
// saved BEFORE that fix still carry raw HTML and epoch-garbage timestamps in
// the database — these guards make sure the UI never shows tag soup,
// "Invalid Date", or 1970.

/** Strip HTML tags/entities and collapse whitespace for card previews. */
export const cleanText = (s?: string | null): string =>
  (s || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&quot;/gi, '"')
    .replace(/\s+/g, " ")
    .trim();

/** Format a posting date defensively — garbage in, "Recently" out. */
export const formatPostedDate = (iso?: string | null): string => {
  if (!iso) return "Recently";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime()) || d.getFullYear() < 2000) return "Recently";
  return d.toLocaleDateString();
};

/** Human-readable names for job-board source badges. */
export const BOARD_LABELS: Record<string, string> = {
  adzuna: "Adzuna",
  jsearch: "JSearch",
  remoteok: "RemoteOK",
  themuse: "The Muse",
  arbeitnow: "Arbeitnow",
};
